// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1639415928389
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/scss/core/_dropdown-menu-right.scss
// module id = ./src/scss/core/_dropdown-menu-right.scss
// module chunks = 0